import { Switch } from 'react-router-dom';
import PrivateRoute from 'routes/PrivateRoute';
import RegisterActivities from './RegisterActivities';
import RegisterAddress from './RegisterAddress';
import RegisterAgenda from './RegisterAgenda';
import RegisterBank from './RegisterBank';
import RegisterConfig from './RegisterConfig';
import RegisterDocuments from './RegisterDocuments';
import RegisterEmployee from './RegisterEmployee';
import RegisterEnd from './RegisterEnd';
import RegisterIdentity from './RegisterIdentity';
import RegisterInsurance from './RegisterInsurance';
import RegisterPolicies from './RegisterPolicies';
import routes from 'config/routes';
import RegisterDescription from './RegisterDescription';

function RegisterArea() {
  return (
    <Switch>
      <PrivateRoute path={routes.register.activities.root}>
        <RegisterActivities />
      </PrivateRoute>
      <PrivateRoute path={routes.register.agenda.root}>
        <RegisterAgenda />
      </PrivateRoute>
      <PrivateRoute path={routes.register.description.root}>
        <RegisterDescription />
      </PrivateRoute>
      <PrivateRoute path={routes.register.bank.root}>
        <RegisterBank />
      </PrivateRoute>
      <PrivateRoute path={routes.register.config.root}>
        <RegisterConfig />
      </PrivateRoute>
      <PrivateRoute path={routes.register.contract.root}>
        <RegisterPolicies />
      </PrivateRoute>
      <PrivateRoute path={routes.register.end.root}>
        <RegisterEnd />
      </PrivateRoute>
      <PrivateRoute path={routes.register.identity.root}>
        <RegisterIdentity />
      </PrivateRoute>
      <PrivateRoute path={routes.register.insurance.root}>
        <RegisterInsurance />
      </PrivateRoute>
      <PrivateRoute path={routes.register.kbis.root}>
        <RegisterDocuments />
      </PrivateRoute>
      <PrivateRoute path={routes.register.place.root}>
        <RegisterAddress />
      </PrivateRoute>
      <PrivateRoute path={routes.register.team.root}>
        <RegisterEmployee />
      </PrivateRoute>
    </Switch>
  );
}

export default RegisterArea;
